// utils/exportHelpers.js (or inline at top of this file)

export const escapeCSVCell = (value) => {
  if (value === null || value === undefined) return "";
  const s = String(value);
  // Wrap in quotes if it contains comma, quote, newline
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

export const downloadCSV = (rows, columns, filename) => {
  if (!rows.length) {
    // still allow exporting headers
    const header = columns.map((c) => escapeCSVCell(c.title)).join(",");
    triggerDownload(`${header}\n`, filename);
    return;
  }

  const header = columns.map((c) => escapeCSVCell(c.title)).join(",");
  const body = rows
    .map((row) =>
      columns.map((c) => escapeCSVCell(c.value(row))).join(","),
    )
    .join("\n");

  triggerDownload(`${header}\n${body}\n`, filename);
};

export const triggerDownload = (csvContent, filename) => {
  // Prepend BOM so Excel opens UTF-8 correctly
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const stamp = () => new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");